import { NUMBER_SIZE } from '../../../constants/size'
import { ICON_CHEVRON_DIRECTION } from '../../Icon'

export const NAV_ARROW_BUTTON_DIRECTION = ICON_CHEVRON_DIRECTION.RIGHT

export const NAV_ARROW_BUTTON_SIZE = NUMBER_SIZE.size40
